<div class="container-fluid">
    <mat-toolbar class="toolbar-bg-blue">
        <h2>Create Holiday</h2>
        <div class="forModalClose">
            <span (click)="cancel()">X</span>
        </div>

    </mat-toolbar>
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="isShowAlert">
        <b> Holiday created successfully.</b>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="holidayForm" #myForm="ngForm" (ngSubmit)="holidayFormSubmit()">

        <mat-form-field *ngIf="isShowOrganization">
            <mat-label>Organizations</mat-label>
            <mat-select formControlName="org_id">
                <mat-option *ngFor="let organization of organizations;" [value]="organization?.org_id">{{organization?.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="holidayFormValidate?.org_id?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Holiday For</mat-label>
            <input type="text" formControlName="holiday_for" matInput>
            <mat-error *ngIf="holidayFormValidate?.holiday_for?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Holiday On</mat-label>
            <input matInput formControlName="holiday_on" [matDatepicker]="holiday_date" (focus)="holiday_date.open()">
            <mat-datepicker-toggle matSuffix [for]="holiday_date"></mat-datepicker-toggle>
            <mat-datepicker #holiday_date></mat-datepicker>
            <mat-error *ngIf="holidayFormValidate?.holiday_on?.errors?.required">This field is required.</mat-error>

        </mat-form-field>

        <div class="footer-block text-center">
            <div class="button-group">
                <button type="submit" mat-raised-button class="btn-int-blue">Create </button>
            </div>
        </div>
    </form>
</div>